import React from "react";
import { getLocalizedString } from "@icarius-localization/strings";
import { CloseIcon } from "@icarius-icons";
import {
  Grid,
  DialogContent,
  DialogActions,
  DialogTitle,
  Dialog,
  Typography
} from "@material-ui/core";
import DialogTitleDivider from "@icarius-common/dialogTitleDivider";
import ButtonDialogAction from "@icarius-common/buttonDialogAction";
import DialogTransition from "@icarius-common/dialogTransition";
import PaperDraggable from "@icarius-common/paperDraggable";
import TextFieldMultiline from "@icarius-common/textFieldMultiline";

const CalcProcessTraceability = (props) => {

  const {
    open,
    data,
    calcProcessName,
    handleClose,
  } = props;

  return (
    <Dialog
      TransitionComponent={DialogTransition}
      PaperComponent={PaperDraggable}
      open={open}
      scroll={"paper"}
      fullWidth
      maxWidth={"md"}>
      <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">
        {`${getLocalizedString("calcProcessTraceability")} - ${calcProcessName}`}
        <DialogTitleDivider />
      </DialogTitle>
      <CloseIcon className={"dialog-close-icon icon"} onClick={handleClose} />
      <DialogContent style={{ paddingTop: 0 }}>
        <Grid container item xs={12} >
          <Grid container item alignItems="center" xs={12} style={{ padding: "10px" }}> {/* Trazabilidad del proceso de cálculo */}
            <TextFieldMultiline
              fullWidth
              rows={25}
              margin={"none"}
              value={data}
              inputProps={{ spellCheck: 'false' }}
            />
          </Grid>
        </Grid>

      </DialogContent>
      <Grid container item alignItems="center" xs={12} style={{ padding: "0px 30px" }}>
        <Typography
          style={{ color: "red", fontWeight: "bold" }}>
          {getLocalizedString("ctrlfToSearchTextWithinTrace")}
        </Typography>
      </Grid>
      <DialogActions>
        <ButtonDialogAction onClick={handleClose} text={getLocalizedString("close")} />
      </DialogActions>
    </Dialog>
  );
}

export default CalcProcessTraceability;
